'use client';
import { jsx, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getAssetsMap } from '@vtmn-play/assets/react';

const VpAsset = forwardRef((props, ref) => {
  const { name, width, height, className, ...restProps } = props;
  if (!name) return /* @__PURE__ */ jsx(Fragment, {});
  const newAssets = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Object.entries(getAssetsMap()).filter(([_, value]) => !!value)
  );
  const AssetComponent = Object.fromEntries(newAssets)[name] || (() => /* @__PURE__ */ jsx(Fragment, {}));
  return /* @__PURE__ */ jsx(
    AssetComponent,
    {
      className,
      width,
      height,
      ref,
      "aria-hidden": true,
      ...restProps
    }
  );
});

export { VpAsset };
